import { useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { showToast } from "../../../../components/common/notification/Notification";
import PromotionDetailCard from "../PromotionDetailCard";
import { useNavigate } from "react-router-dom";

const Step3PreviewForm = ({ prevStep, formData, onPromotionCreated }) => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const loggedInUser = useSelector((state) => state.auth.user);
  console.log(loggedInUser.user.first_name); 
  const token = loggedInUser?.refreshToken;
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const assetUrl = process.env.REACT_APP_ASSET_URL;
    console.log("Submitting form data:", formData);

  const handleSubmit = async () => {
    setLoading(true);

    try { 
      const images = (formData.media.images || []).map((img) => ({
        imagePath: img.imagePath || null,
        active: false,
        deleted: false,
        id: null,
        created_on: null,
        name: img.name || null,
        description: null,
        image_url: (img.image_url || "").replace(assetUrl, ""),
      }));

      const promotion_videos = (formData.media.promotion_videos || []).map((video) => ({
        active: false,
        deleted: false,
        id: null,
        created_on: null,
        name: null,
        description: null,
        url_path: (video.url || "").replace(assetUrl, ""),
      }));

      const attachements = (formData.media.attachments || []).map((attachment) => ({
        attachmentPath: attachment.name || null,
        active: false,
        deleted: false,
        id: null,
        created_on: null,
        name: null,
        description: null,
        attachment_url: (attachment.url || "").replace(assetUrl, ""),
      }));

      const payload = {
        project_name: formData.project_name,
        project_description: formData.project_description,
        starting_cost: formData.starting_cost,
        type_id: formData.type_id || 1,
        city_name: formData.city_name,
        state_name: formData.state_name,
        country_name: formData.country_name,
        pin_code: formData.pin_code,
        area_name: formData.area_name,
        images,
        attachements,
        promotion_videos,
      };

      console.log("Payload to submit:", payload);

      const response = await axios.post(`${baseUrl}/promotion/add`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log("Response from server:", response);

      if (response.data.statusType === "SUCCESS") {
        showToast('Promotion created successfully!', { type: 'success' });
        setTimeout(() => {
          navigate("/promotion-list");
        }, 2000);

      } else {
        showToast("Promotion submission failed. Please try again.", { type: "error" });
      }

    } catch (error) {
      console.error("Error during submission:", error);
      showToast("Failed to submit promotion", { type: "error" });
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className="container py-4">
      <h5 className="mb-3">Step 3: Review Your Submission</h5>
      <div className="card shadow-sm border mb-3 p-4">

        <PromotionDetailCard 
          images={(formData.media.images || []).map((img) => ({
            url: img.image_url,
          }))}
          videos={(formData.media.promotion_videos || []).map((video) => ({
            url: video.url,
          }))}
          attachments={(formData.media.attachments || []).map((attachment) => ({
            url: attachment.url,
          }))}
          title={formData.project_name || "Untitled Project"}
          description={formData.project_description || "No description provided."}
          cost={formData.starting_cost || "0"}
          type={formData.type_id ? `Type ${formData.type_id}` : "Not specified"}
          state={formData.state_name || "Not specified"}
          city={formData.city_name || "Not specified"}
          pin_code={formData.pin_code || "Not specified"}
          photo={loggedInUser?.photo || ""}
          creater={loggedInUser?.user?.first_name || "Unknown User"}
        />

        {console.log("Form Data in Preview Step:",
        // formData,
        // formData.media.images,
         (formData.media.images || []).map((img) => ({
            url: img.image_url,
          }))
        )}

      </div>

      <div className="d-flex justify-content-between mt-3">
        <button className="btn btn-secondary" onClick={prevStep}>Previous</button>
        <button className="btn btn-success" onClick={handleSubmit} disabled={loading}>
          {loading ? "Submitting..." : "Submit"}
        </button>
      </div>
    </div>
  );
};

export default Step3PreviewForm;
